<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      screenHeight: 0,
      canChange: true, // resize节流
      newHeight: 0
    };
  },
  watch: {
    'screenHeight': function (val) { //监听屏幕高度变化
      this.newHeight = val;
      if (!this.timer) {
        this.timer = true;
        let self = this;
        setTimeout(function () {
          var box = document.getElementById('app');
          box.style.height = Number(self.newHeight) + 'px';
          self.timer = false;
        }, 500)
      }
    }
  },
  created () {
    var self = this;
    self.screenHeight = document.documentElement.clientHeight;
    window.onresize = function () { // 定义窗口大小变更通知事件
      self.screenHeight = document.documentElement.clientHeight; //窗口高度
    };
  }
}
</script>

<style>
#app {
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue